import * as XLSX from "xlsx";


const fixWidth = (worksheet) => {
    const data = XLSX.utils.sheet_to_json(worksheet)
    const colLengths = Object.keys(data[0]).map((k) => k.toString().length)
    for (const d of data) {
        Object.values(d).forEach((element, index) => {
            const length = element.toString().length
            if (colLengths[index] < length) {
                colLengths[index] = length
            }
        })
    }
    worksheet["!cols"] = colLengths.map((l) => {
        return {
            wch: l*2,
        }
    })
}

export const exportExcel = (tableRef, filename) => {
    const worksheet = XLSX.utils.table_to_sheet(tableRef.current);
    //const worksheet = XLSX.utils.json_to_sheet(exportBody);
    fixWidth(worksheet);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, filename);

    return;
};


